import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getPageUrl } from '../Redux/actions/userActions'

const GetPageURL = ({ url }) => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getPageUrl(url))
  }, [dispatch, url])

  return <> </>
}

export default GetPageURL
